import React, { useEffect } from 'react';
import { useNavigate } from "react-router";
import { useUserAuth } from "../context/UserAuthContext";
import axios, {head} from 'axios';
import CryptoJS from 'crypto-js';
const HubSpotAuth = () => {
    const { logOut, user } = useUserAuth();
    const navigate = useNavigate();

    function getHubSpotId(access_token){
        let account_info_url = "https://api.hubapi.com/account-info/v3/details"
        let headers = {"content-type": "application/json", "authorization": "Bearer " + access_token}

        fetch(account_info_url, {method: 'POST', headers: headers}).then( response => {
            let portal_id = response.json()['portalId']
            return portal_id;
        });
        return null
    }

    useEffect(() => {
        const oauthCode = new URLSearchParams(window.location.search).get('code');

        if (oauthCode) {
            console.log("Oauth code known");
            console.log(oauthCode);
            const formData = {
                oauthCode: oauthCode
            };

            const postOAuthCode = async () => {
                console.log("Starting Promise");
                try {
                    console.log("Running Promise");

                    // Assuming formData is defined somewhere above this code
                    const requestOptions = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json','Authorization': "Bearer " + user.accessToken},
                        body: JSON.stringify(formData)
                    };
                    const response = fetch('https://pro-tools-api-hw0mg03.wl.gateway.dev/retrieve-access-token', requestOptions);

                    // Handle the returned tokens
                    console.log(response.data);
                    let accessToken = response.data.access_token; // Correct key name (usually lowercase)
                    let refreshToken = response.data.refresh_token;
                    let portalId = await getHubSpotId(accessToken); // Make sure getHubSpotId is an async function if it returns a promise

                    console.log(portalId);
                    navigate("/auth-success");

                    return response.data; // Return the data if needed

                } catch (error) {
                    console.log("Not Working");
                    console.error(error); // Log the error to understand what went wrong
                    return null
                }
            };
            let tokenData = postOAuthCode();

        } else{
            console.log("No Code Found");
        }
    });
    const handleLogout = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <>
            <div>
                <h1>
                    You are installing HubSpot...
                </h1>
            </div>
        </>
    );
};

export default HubSpotAuth;